import React from "react";
import { Typography, MarkdownContainer } from "@shared/ui.primitives";

import * as styles from "./TrialResultItem.css";

type Props = {
  label: string;
  value: string;
};

export const TrialResultItem: React.FC<Props> = ({ label, value }) => {
  return (
    <div className={styles.card}>
      <Typography as="h2" variant="subheader-2" color="primary-dark">
        {label}
      </Typography>
      <MarkdownContainer
        content={value}
        tagOverrides={{
          h2: {
            component: Typography,
            props: {
              as: "h2",
              variant: "subheader-6",
              colour: "primary-dark"
            }
          },
          h4: {
            component: Typography,
            props: {
              as: "h6",
              variant: "subheader-6",
              colour: "primary-dark"
            }
          },
          p: {
            component: Typography,
            props: {
              as: "p",
              variant: "smallprint-md",
              colour: "primary-dark"
            }
          },
          span: {
            component: Typography,
            props: {
              as: "span",
              variant: "smallprint-md",
              colour: "primary-dark"
            }
          },
          b: {
            component: Typography,
            props: {
              as: "strong",
              variant: "smallprint-md-bold",
              colour: "primary-dark"
            }
          }
        }}
        forceBlock={true}
      />
    </div>
  );
};
